module.exports = __webpack_public_path__ + "img/Accesscontrolgray.fd853b2e.svg";